// Mieter-/Eigentümer-Login: Portal nur, wenn es eingeschaltet ist (app_settings 'portale_funktionen',
// gelesen über portal_freigeschaltet() – Portal-Logins dürfen app_settings selbst nicht lesen).
// Aus, nicht eingespielt oder Fehler → Hinweis „Ihr Portal ist bald verfügbar“.
// Routen: /mieterportal/:tab bzw. /portal/:tab; jede andere Adresse (auch /admin) leitet dorthin um.
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CircleNotch } from '@phosphor-icons/react';
import { supabase } from '../../lib/supabase/client';
import ZugangHinweis from './ZugangHinweis';
import MieterPortal from '../../pages/mieterportal/MieterPortal';
import EigentuemerPortal from '../../pages/eigentuemerportal/EigentuemerPortal';

export interface PortalProfil { id: string; role?: string | null; full_name?: string | null; email?: string | null }

export default function PortalWeiche({ profil }: { profil: PortalProfil }) {
  const [frei, setFrei] = useState<boolean | null>(null);

  useEffect(() => {
    let aktiv = true;
    void supabase.rpc('portal_freigeschaltet').then(({ data, error }) => {
      if (!aktiv) return;
      if (error) console.warn('Portal-Schalter nicht lesbar:', error.message);
      setFrei(data === true);
    });
    return () => { aktiv = false; };
  }, []);

  if (frei === null) {
    return (
      <div data-theme="dark" className="portal-flaeche" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-busy="true" aria-label="Lädt">
        <CircleNotch size={26} weight="bold" className="animate-spin" style={{ color: 'var(--p-w40)' }} />
      </div>
    );
  }
  if (!frei) return <ZugangHinweis art="portal" />;

  const mieter = (profil.role ?? '').toLowerCase() === 'mieter';
  const basis = mieter ? '/mieterportal' : '/portal';
  return (
    <Routes>
      <Route path={`${basis}/:tab?`} element={mieter ? <MieterPortal profil={profil} /> : <EigentuemerPortal profil={profil} />} />
      <Route path="*" element={<Navigate to={basis} replace />} />
    </Routes>
  );
}
